import api from './api'

// Типы
export interface Trainer {
  id: string
  user: {
    id: string
    first_name: string
    last_name?: string
    photo_url?: string
  }
  specialization?: string
  status: 'pending' | 'trial' | 'approved' | 'rejected' | 'frozen' | 'blocked'
  trial_state?: 'available' | 'booked' | 'completed'
}

export interface TrialBookingInfo {
  status: 'available' | 'booked' | 'completed'
  can_book: boolean
  booking_date?: string
  booking_time?: string
}

export interface AvailableSlot {
  id: string
  date: string
  start_time: string
  end_time: string
  status: string
  max_clients?: number
  available_spots?: number
}

// API
export async function getMyTrainers() {
  const response = await api.get<{
    trainers: Trainer[]
    total: number
  }>('/clients/me/trainers')
  return response.data
}

export async function getTrainerSlots(
  trainerId: string,
  dateFrom?: string,
  dateTo?: string
) {
  const params: Record<string, string> = {}
  if (dateFrom) params.date_from = dateFrom
  if (dateTo) params.date_to = dateTo

  const response = await api.get<{
    slots: AvailableSlot[]
    total: number
    trial_booking_info: TrialBookingInfo | null
  }>(`/clients/me/trainers/${trainerId}/slots`, { params })
  return response.data
}

export async function registerByInviteCode(inviteCode: string) {
  const response = await api.post<{
    message: string
    trainer?: {
      first_name: string
      specialization?: string
    }
    status: string
  }>(`/clients/register/${inviteCode}`)
  return response.data
}
